import {Component, inject, OnInit} from '@angular/core';
import {StorageService} from "../../../../services/storage.service";
import {select, Store} from "@ngrx/store";
import {AppState} from "../../../../store/reducers";
import {AuthService} from "../../../../services/auth.service";
import {ActivatedRoute} from "@angular/router";
import {
  FormResponseStatusEnum
} from "../../../../store/entities/citizens/my-requested-services/my-requested-services.model";
import {Observable, Subscription} from "rxjs";
import {TranslateService} from "@ngx-translate/core";
import {Apollo} from "apollo-angular";
import {Location} from "@angular/common";
import {environment} from "../../../../../environments/environment.prod";
import {
  citizenGetFormResponses, closeRequest
} from "../../../../store/entities/service-management/form-response/form-response.actions";
import {
  selectModifiedFromResponseByUid
} from "../../../../store/entities/service-management/form-response/form-response.selectors";
import {
  FormResponse,
  FormResponseAttachmentInput
} from "../../../../store/entities/service-management/form-response/form-response.model";
import {AttachmentService} from "../../../../services/attachment.service";
import {
  citizenGetServicesDeliveryProcedureSteps
} from "../../../../store/entities/citizens/citizens-services-delivery-procedure-steps/citizens-services-delivery-procedure-steps.actions";
import {
  CitizensServicesDeliveryProcedureSteps
} from "../../../../store/entities/citizens/citizens-services-delivery-procedure-steps/citizens-services-delivery-procedure-steps.model";
import {
  selectModifiedServiceDeliveryProcedureSteps
} from "../../../../store/entities/citizens/citizens-services-delivery-procedure-steps/citizens-services-delivery-procedure-steps.selectors";
import {
  GET_SERVICE_FORM_RESPONSE_ATTACHMENTS,
  GET_SERVICE_FORM_RESPONSE_COMMENTS
} from "../../../../modules/service-management/service-form-response-list/service-form-response-view/resend_form_response.gql";
import {map} from "rxjs/operators";
import {
  CLOSE_SERVICE_REQUEST_MUTATION
} from "../../../../store/entities/service-management/form-response/form-response.graphql";
import {FormBuilder, Validators} from "@angular/forms";
import {NotificationService} from "../../../../services/notification.service";


@Component({
  selector: 'app-request-details',
  templateUrl: './request-details.component.html',
  styleUrl: './request-details.component.scss'
})
export class RequestDetailsComponent implements OnInit{

  private attachmentService: AttachmentService = inject(AttachmentService)
  private fb: FormBuilder = inject(FormBuilder)

  formUniqueId: string;
  attachments$: Observable<any[]>;
  comments$:   Observable<any[]>;
  commentForm  = this.fb.nonNullable.group({ comment: ['', Validators.required] });
  private notificationService: NotificationService = inject(NotificationService)
  currentProfileUniqueId = '';


  fileServer: string = environment.FILE_SERVER_URL
  currentTabIndex = 0

  formResponse$: Observable<FormResponse>;

  responseTabs: { name: string; slug: 'current' | 'tracking' }[] = [
    {
      name: 'Majibu ya Sasa',
      slug: 'current',
    },
    {
      name: 'Majibu yaliyopita',
      slug: 'tracking',
    }
  ]
  activeSlug: 'current' | 'tracking' = 'tracking';

  subscription$: Subscription = new Subscription();
  serviceSteps$:Observable<CitizensServicesDeliveryProcedureSteps[]>;

  submittedFormData: { label: string, value: string }[] = []

  constructor(
    private storageService: StorageService,
    private store: Store<AppState>,
    private authService: AuthService,
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private apollo: Apollo,
    private location: Location
  ) {
    this.formUniqueId = this.route.snapshot.paramMap.get('uniqueId');

  }

  ngOnInit() {
    this.store.dispatch(citizenGetFormResponses({}));

    this.formResponse$ = this.store.pipe(select(selectModifiedFromResponseByUid(this.formUniqueId)))
    this.serviceSteps$ = this.store.select(selectModifiedServiceDeliveryProcedureSteps);

    this.subscription$.add(this.formResponse$.subscribe(formResponse => {
      if (formResponse) {
        this.submittedFormData = []
        const responsePayload = JSON.parse(formResponse?.responsePayload)
        const formConfiguration = JSON.parse(formResponse?.form?.configuration)

        for (const responseKey of Object.keys(responsePayload)) {
          const dataIndex: number = this.submittedFormData?.findIndex(c => c.label === responsePayload[responseKey])
          if (dataIndex < 0) {
            this.submittedFormData.push({
              label: formConfiguration?.find(c => c.key === responseKey)?.label,
              value: responsePayload[responseKey],
            })
          }
        }
        this.store.dispatch(citizenGetServicesDeliveryProcedureSteps({serviceUniqueId: formResponse?.form?.service?.serviceUniqueId }));
      }
    }))
    this.loadAttachmentsAndComments();

  }

  async openAttachment(base64String: string) {
    this.attachmentService.viewBase64PdfInModal(`data:application/pdf;base64,${base64String}`)
  }

  private loadAttachmentsAndComments() {
    if (!this.formUniqueId) return;

    const filtering = { formResponse: this.formUniqueId };

    this.attachments$ = this.apollo
      .watchQuery({
        query: GET_SERVICE_FORM_RESPONSE_ATTACHMENTS,
        variables: { filtering },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        map((r: any) => r?.data?.getServiceFormResponseAttachments?.data ?? [])
      );

    this.comments$ = this.apollo
      .watchQuery({
        query: GET_SERVICE_FORM_RESPONSE_COMMENTS,
        variables: { filtering },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        map((r: any) => {
          const comments = r?.data?.getServiceFormResponseComments?.data ?? [];
          return [...comments].sort(
            // (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime() --descend
            (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
        );
        })
      );
  }

  sendComment() {
    if (this.commentForm.invalid) return;
    this.apollo
      .mutate({
        mutation: CLOSE_SERVICE_REQUEST_MUTATION,
        variables: {
          input:{
            requestUniqueId: this.formUniqueId,
            comment: this.commentForm.value.comment,
          }
        },
        fetchPolicy: 'no-cache',
      })
      .pipe(this.notificationService.catchError('Comment Error'))
      .subscribe(() => {
        this.commentForm.reset();
        this.loadAttachmentsAndComments();
      });
  }

  closeRequest() {
    const attachments: FormResponseAttachmentInput[] = [];
    const comment = this.commentForm.value.comment ?? '';

    const message = 'Are you sure you want to close request?';
    this.notificationService.confirmation(message, 'Close').then(({ value }) => {
      if (value) {
        this.store.dispatch(
          closeRequest({
            requestUniqueId: this.formUniqueId,
            attachments: attachments,
            comment: comment,
          })
        );
      }
    });
  }

  isAttachment(value: string) {
    return typeof value === 'string' && value.includes('data:application');

  }

  private setCurrentProfile(uid: string | undefined) {
    if (uid && !this.currentProfileUniqueId) this.currentProfileUniqueId = uid;
  }
  protected readonly FormResponseStatusEnum = FormResponseStatusEnum;
}
